import { FC } from 'react';
import styles from './NoticeBanner.module.scss';

export interface NoticeBannerProps {
  children?: React.ReactNode;
}

export const NoticeBanner: FC<NoticeBannerProps> = ({ children }) => {
  return (
    <aside className={styles.notice} aria-label="Design direction information">
      <div className={styles.icon} aria-hidden="true">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="16" x2="12" y2="12" />
          <line x1="12" y1="8" x2="12.01" y2="8" />
        </svg>
      </div>
      <p className={styles.text}>
        {children || (
          <>
            <strong>Design direction:</strong> the rebuild retains familiar Pulse categories and building information,
            while replacing the dense portal layout with focused tasks, reliable search and connected records.
          </>
        )}
      </p>
    </aside>
  );
};
